import { postRequest } from '../../../shared/utils';

export async function validateSaphHtzService(htz: string, screenGridId: number) {
  const body = {
    columns: ['htz', 'e_saph_id'],
    screenGridId,
    schema: 'npi',
    table: 'tblhtzinfo',
    key: 'htz',
    value: htz,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    console.error(errors);
    return null;
  }

  return data;
}
